<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        value-key="IdGrupo"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('groups.link_groups')" icon="link" v-if="EsPropietario && !isRoleUserOrConsulta" @click="golinkGroupToInvoice" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :baseDropDownVisible="accionesFinal.length > 0"
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesFinal" :key="action.id">
            <base-button-item-list theme="dark"  @click="executeAction(action)">
              <base-icon :name="action.icon" class="mr-2" />
              {{ action.name }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <invoice-link-groups-dialog 
        :dialogOpen="linkGroupToFacturaDialog" multiple
        :idFacturae="idFacturae" :idInvoice="idInvoice"
        @toggleDialog="toggleDialogs" 
        @applyDialog="applyLinkHandler" 
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" :generalView="false" :vuexnamespace="vuexnamespace"/>
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/GroupsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { GetFacturaGruposPag } from '@/services/invoices/GetFacturaGruposPag'
import { getInvoice } from '@/services/invoices/getInvoice'
import { i18n } from '@/i18n'
import '@progress/kendo-theme-default/dist/all.css'

import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import InvoiceLinkGroupsDialog from '@/components/InvoiceLinkGroupsDialog.vue'
import { linkGroupToInvoice } from '@/services/configurations/groups/linkGroupToInvoice'
import { unlinkGroupToInvoice } from '@/services/configurations/groups/unlinkGroupToInvoice'
import { changeOwnerInvoice } from '@/services/configurations/groups/changeOwnerInvoice'
import { GetFacturaGruposExcel } from '@/services/configurations/GetFacturaGruposExcel'

export default {
  name: 'list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    InvoiceLinkGroupsDialog
  },
  data: function () {
    return {
      idVista: 53,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkGroupToFacturaDialog: false,
      spanish: true,
      EsPropietario: false,
      header: {
        title: i18n.t('groups.groups_link'),
        icon: 'config',
        breadcrumb: null,
        url: ''
      },
      acciones: [
        {
          id: 1,
          name: i18n.t('app.unlink_entity'),
          icon: 'unlink',
        },
        {
          id: 2,
          name: i18n.t('groups.set_as_owner'),
          icon: 'key',
        }
      ],
      vuexnamespace: 'invoicegroups',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      numFactura: '',
      idEstado: '',
      data: null,
      selected: [],
    }
  },
  computed: {
    recibida: function () {
      return this.$route.meta?.recibida
    },
    tiposEstados: function () {
      if (this.esRecibida) {
        return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
      }
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    nombreEstado: function () {
      return this.tiposEstados.find(x => x.id === this.idEstado).Nombre
    },
    accionesFinal () {
      let acciones = this.acciones
      if (!this.EsPropietario) return []
      if (this.selected && this.selected.length > 0) {
        if (this.rowsSelected > 1 || this.selected.filter(x => x.idTipo === 3).length > 0 || this.selected.filter(x => x.Propietario === true).length > 0) {
          acciones = acciones.filter(x => x.id !== 2)
        }
      }
      return acciones
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    idInvoice: function () {
      return parseInt(this.$route.params.idInvoice)
    },
    idFacturae: function () {
      return parseInt(this.$route.params.idFacturae)
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    var invoiceType = this.recibida ? 'received' : 'issued'
    this.header.url = `invoices${invoiceType}/details`
    this.header.params = this.$route.params

    const breadcrumbs = []
    breadcrumbs.push({ path: `invoices${invoiceType}`, name: i18n.t(`invoices.${invoiceType}_header`) })
    // breadcrumbs.push({ path: '' + this.$route.params.type, name: this.form.Estado })
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: `/invoices${invoiceType}/${cabeceraStored.idEstado}`, name: cabeceraStored.NombreEstado })
      breadcrumbs.push({ path: '', name: this.truncate(cabeceraStored.NumFactura, 30, false) })
    } else {
      await this.downloadFacturaData()
      breadcrumbs.push({ path: `/invoices${invoiceType}/${this.idEstado}`, name: this.nombreEstado })
      breadcrumbs.push({ path: '', name: this.truncate(this.numFactura, 30, false) })
      this.$store.commit('app/setheaderBreadCrumb', { NumFactura: this.numFactura, idEstado: this.idEstado, NombreEstado: this.nombreEstado })
    }
    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 1) { // desvincular
        this.unlink()
      } else if (this.selectedAction.id === 2) {
        this.changeOwner()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    downloadFacturaData: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idInvoice: this.idInvoice,
          idFacturae: this.idFacturae,
        }
        const factura = await getInvoice(params)
        if (factura.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', factura))
        }
        this.setFactura(factura.respuesta)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setFactura: function (factura) {
      this.numFactura = factura.NumFactura ? factura.NumFactura : i18n.t('invoices.no_num_factura')
      this.idEstado = factura.idEstado
    },
    openPath: function (event) {
      // this.$router.push({ name: 'configurations/tags/details', params: { id: event.dataItem.IdUsuario } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkGroupToFacturaDialog = !this.linkGroupToFacturaDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getFilters (data) {
      return {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.send_alerts_users ? data.send_alerts_users.value : null,
        propietario: data.propietario ? data.propietario.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      
      const params = {
        idFacturae: this.idFacturae,
        idInvoice: this.idInvoice,
        ...this.getFilters(data)
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await GetFacturaGruposExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'factura-grupos.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idFacturae: this.idFacturae,
        idInvoice: this.idInvoice,
        ...this.getFilters(data)
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await GetFacturaGruposPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      this.EsPropietario = data.EsPropietario
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdTag)
      // }
      this.data = await this.applyFilters()
    },
    changeOwner: async function () {
      const selected = this.selected[0]
      await this.changeOwnerHandler(selected)
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const idInvoice = this.idInvoice
        const idFacturae = this.idFacturae
        const payload = { idInvoiZE: { idFacturae, idInvoice }, idGrupos: [] }
        grupos.forEach(element => {
          payload.idGrupos.push(element)
        })
        const response = await unlinkGroupToInvoice(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.unselect()
        this.$store.commit('setIsLoading', false)
      }
    },
    changeOwnerHandler: async function (grupo) {
      try {
        this.$store.commit('setIsLoading', true)
        const idInvoice = this.idInvoice
        const idFacturae = this.idFacturae
        const payload = { idInvoiZEs: [{ idFacturae, idInvoice }], idGrupo: grupo }
        const response = await changeOwnerInvoice(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.unselect()
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkGroupToInvoice: function () {
      this.linkGroupToFacturaDialog = !this.linkGroupToFacturaDialog
    },
    applyLinkHandler: async function (groups) {
      this.linkGroupToInvoice = false
      await this.linkHandler(groups)
      // for await (const element of groups) {
      //   await this.linkHandler(element)
      // }
      this.applyFilters()
    },
    linkHandler: async function (idGroups) {
      try {
        this.$store.commit('setIsLoading', true)
        const idInvoice = this.idInvoice
        const idFacturae = this.idFacturae
        const payload = { idInvoiZEs: [{ idFacturae, idInvoice }], idGrupos: idGroups }
        const response = await linkGroupToInvoice(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          this.applyFilters()
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.toggleDialogs()
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
